<template>
	<div class="contentPage">
		<main-table-all-back
				v-if="citiesLimit"
				textCreate="Add address"
				:flag="flag"
				page-title="Cities"
				:headers="headers"
				:settings="getSettings"
				:filtersList="citiesFilters"
				:list="citiesList"
				:defaultOrder="citiesOrder"
				:defaultSort="citiesSort"

				:totals="citiesTotals"
				:total-pages="citiesTotal"
				:limit-pages="citiesLimit"
				:pages="[ 15, 50, 100, 200, 500, 'All' ]"
				:uniqId="uniqId"
				@updateSettings="onSettingsOpen"
				@updateEvent="onEvent"
				@updateClickButton="onClickButton"
				@updateList="onList"
				@updateEdit="onEdit"
				@updateRefreshFilters="onUpdateFilters(defaultFilter)"
				@updateExport="onExport"
				isExport
				is-create
				is-settings
		></main-table-all-back>

		<table-settings
				v-if="isTableSettingsDrawer"
				@updateSettingsSave="onSettingsSave('city')"
				@updateSettingsCancel="onSettingsCancel"
				@updateSettingsClose="onSettingsClose"
				@updateSettingsAll="onSettingsAll"
				:settings="getSettings"
		></table-settings>

		<remove-block
				v-if="isRemove"
				@updateRemoveItem="onRemoveItem"
				@updateRemoveClose="onRemoveClose"
		></remove-block>

		<cities-form
				v-if="isCitiesForm"
				:cityId="cityId"
				@updateClose="onCloseDialog"
		></cities-form>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components

// shared
import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack";
// mixins
import settingsMixins from "@/mixins/settingsMixins";
import removeMixins from "@/mixins/removeMixins";
// constants
import { PAGE, PERMISSIONS } from "@/constants/constants";
import CitiesForm from "@/components/Maintenance/Cities/CitiesForm/CitiesForm.vue";

export default {
	name: "Cities",
	mixins: [ settingsMixins, removeMixins ],
	components: { CitiesForm, MainTableAllBack },
	computed: mapGetters([
		"citiesList",
		"citiesFilters",
		"citiesTotals",
		"permissions",
		"citiesOrder",
		"citiesLimit",
		"citiesSort",
		"citiesTotal",
		"statesList",
	]),
	data: () => ({
		flag: PAGE.CITIES,
		isCitiesForm: false,
		defaultFilter: null,
		activeTableFilters: null,
		cityId: null,
	}),
	methods: {
		...mapActions([
			'getCities',
			'getCitiesFilters',
			'actionPreloader',
			'onExportLink',
			'onCitiesRemoveItem',
			'getStatesList'
		]),
		onCloseDialog(isRefresh) {
			this.isCitiesForm = false;
			if (isRefresh) {
				this.onUpdateFilters(this.defaultFilter);
			}
		},
		async onRemoveItem() {
			const { status } = await this.onCitiesRemoveItem(this.removeId);
			if (status) this.isRemove = false;
			await this.onUpdateFilters(this.defaultFilter);
		},
		async onEvent(flag) {
			if (flag === 'create') {
				this.isCitiesForm = true;
				this.cityId = null;
			}
		},
		async onUpdateFilters(filters, isWithoutFilters) {
			await this.getCities(filters);
			if (!isWithoutFilters) await this.getCitiesFilters(filters);
		},
		async onList(values) {
			const { value, flag } = values;
			// сохраняем выбранные фильтры отдельно
			this.activeTableFilters = value;

			switch (flag) {
				case "sorting":
					await this.getCities(value);
					break;
				case "page":
					await this.onUpdateFilters(value, true);
					break;
				default:
					await this.onUpdateFilters(value);
			}
		},
		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'cities' });
		},
		async onClickButton({ key, item }) {
			if (key === 'edit') {
				if (this.permissions[PERMISSIONS.EDIT]) {
					this.cityId = item.id;
					this.isCitiesForm = true;
				}
			}

			if (key === "delete") {
				if (this.permissions[PERMISSIONS.DELETE]) {
					this.getRemoveItem(item.id);
				}
			}
		},
		onEdit({ line }) {
			if (this.permissions[PERMISSIONS.EDIT]) {
				this.cityId = line.id;
				this.isCitiesForm = true;
			}
		},

	},
	async mounted() {
		await this.onUpdateFilters();
		await this.getStatesList();
	}
};
</script>
